export default __webpack_public_path__ + "static/media/ライ.71c54569.PNG";